import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Client from "../../../utils/client";
import { api_url } from "../../../constant";
import { toast } from "react-toastify";
import AuthCode from "react-auth-code-input";
import handelPhonenumber from "../../../utils/handel_phonenumber";

function ChangePhonenumber() {
  const [otp, setOtp] = useState(false);
  const [phonenumber, setPhonenumber] = useState("");
  const [code, setCode] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onSubmit", reValidateMode: "onSubmit" });
  const handleOnChange = (res) => {
    setCode(res);
  };

  const onSubmit = async (data) => {
    const formattedPhonenumber = handelPhonenumber(data.newPhonenumber);
    setPhonenumber(formattedPhonenumber);

    try {
      const res = await Client.post(
        api_url + "/users/change-phonenumber-request",
        { newPhonenumber: formattedPhonenumber, password: data.password },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      ).then((res) => {
        res.data();
      });
    } catch (error) {
      if (error.response.data.status === 402) {
        toast("رقم الهاتف القديم والجديد متشابهان", { type: "error" });
      } else if (error.response.data.status === 401) {
        toast("كلمة المرور خاطئة", { type: "error" });
      } else if (error.response.data.status === 405) {
        toast("رقم الهاتف مسجل مسبقاً", { type: "error" });
      } else if (
        error.response.data.code === "VERIFICATION_CODE_ALREADY_SENT"
      ) {
        setOtp(true);
      } else if (error.response.data.code === "BAD_REQUEST") {
        toast("رقم الهاتف  غير صالح", { type: "error" });
      }
    }

    // // if (res.ok) setOtp(true);
    // console.log(res);
  };
  const verify = async () => {
    const res = await Client.post(
      api_url + "/users/change-phonenumber",
      {
        verificationCode: code.toString(),
        phonenumber,
      },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then(() => {
        localStorage.removeItem("token");
        window.location.reload();
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast("رمز التحقق خاطئ", { type: "error" });
        }
      });
  };
  return (
    <div className="my-10 px-5 lg:px-7" dir="rtl">
      {otp && (
        <div
          className={`absolute w-screen h-screen bg-black z-50 bg-opacity-50 flex justify-center items-center 
          
        }`}
        >
          <div className="w-96 h-96 bg-white flex flex-col text-center justify-evenly items-center rounded-lg border-primary border-[2px]">
            <div className="font-bold">
              <div className="mb-2">
                الرجاء إدخال رمز التحقق المرسل لرقم الهاتف
              </div>
              <p dir="ltr">{`${phonenumber}`}</p>
            </div>
            <div dir="ltr">
              <AuthCode onChange={handleOnChange} inputClassName="input" />
            </div>

            <button
              className="bg-primary w-20 h-10 rounded-md text-white"
              onClick={() => verify()}
            >
              موافق
            </button>
          </div>
        </div>
      )}
      <h1 className="lg:text-start font-bold text-start text-xl lg:text-[24px] my-14 lg:my-10">
        تغيير رقم الهاتف
      </h1>
      <form
        onSubmit={handleSubmit(onSubmit)}
        dir="rtl"
        className="flex flex-col gap-3 lg:w-[30%] lg:mr-24"
      >
        <div className="flex flex-col gap-3">
          <label htmlFor="newPhonenumber" className="font-bold text-sm">
            رقم الهاتف الجديد
          </label>
          <input
            type="text"
            dir="ltr"
            name="newPhonenumber"
            className="rounded-lg focus:ring-0 focus:border-primary placeholder:text-sm text-end placeholder:text-end placeholder:m-0"
            placeholder="إدخل رقم الهاتف الجديد"
            {...register("newPhonenumber", {
              required: true,
            })}
          />
        </div>
        <div className="flex flex-col gap-3">
          <label htmlFor="password" className="font-bold text-sm">
            كلمة المرور
          </label>
          <input
            type="password"
            name="password"
            className="rounded-lg focus:ring-0 focus:border-primary placeholder:text-sm"
            placeholder="إدخل كلمة المرور "
            {...register("password", { required: true })}
          />
        </div>
        <button
          type="submit"
          className="w-full text-white bg-primary py-2 mt-3 rounded-lg"
        >
          تأكيد
        </button>
      </form>
    </div>
  );
}

export default ChangePhonenumber;
